<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/germany/ahr/jean-stodden')">Jean Stodden
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/germany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Ahr</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Molto piccolo e molto a nord, Ahr è associato alla crescente tendenza cooperativa di produrre Spätburgunder (Pinot Noir). Questa regione è coltivata a Pinot Noir (64,7%), Riesling (8,2%), Pinot Noir Précoce (6,2%) e viene menzionata in quanto è praticamente sconosciuta al di fuori della Germania, offrendo agli esperti investitori di vino un vantaggio quando si considera il loro portafoglio. Ancora qualcosa di un carattere jolly, ci sono alcune eccezioni degne di nota che includono xxxx.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Ahr</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Sehr klein und sehr nördlich gelegen, ist Ahr mit dem wachsenden genossenschaftlichen Trend zur Herstellung von Spätburgunder (Pinot Noir) verbunden. Diese Region ist mit Pinot Noir (64,7 %), Riesling (8,2 %) und Pinot Noir Précoce (6,2 %) bestockt und wird erwähnt, da sie außerhalb Deutschlands praktisch unbekannt ist, was versierten Weininvestoren einen Vorsprung bei der Betrachtung ihres Portfolios verschafft. Immer noch so etwas wie ein Platzhalter, es gibt einige bemerkenswerte Ausnahmen, die xxxx enthalten.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Ahr</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Très petite et très septentrionale, l'Ahr est associée à la tendance coopérative montante à faire du Spätburgunder (Pinot Noir). Cette région est plantée de Pinot Noir (64,7%), Riesling (8,2%), Pinot Noir Précoce (6,2%) et obtient une mention car elle est pratiquement inconnue en dehors de l'Allemagne, offrant aux investisseurs avertis en vin une longueur d'avance lors de l'examen de leur portefeuille. Toujours quelque chose d'un caractère générique, il existe quelques exceptions notables qui incluent xxxx.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Ahr</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Very small and very north, Ahr is associated with the rising cooperative trend of making Spätburgunder (Pinot Noir). This region is planted with Pinot Noir (64.7%), Riesling (8.2%), Pinot Noir Précoce (6.2%) and gets a mention as it is practically unknown outside of Germany, offering savvy wine investors a head start when considering their portfolio. Still something of a wildcard, there are some notable exceptions that include xxxx.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Ahr",
    data() {
        return {
            select: {report: 'Please choose', src: '#'},
            items: [
                {report: 'Jean Stodden', src: '/wine-guide/germany/ahr/jean-stodden'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    },
    head: {
        title: 'Ahr fine wine | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the unique and diverse wine varietals of the Ahr wine region. From rich, full-bodied reds to crisp whites, experience the best of this beautiful and historic German wine producing area.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}

.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
